<template>
  <div class="d-flex justify-conten-center">
    <div class="col-md-3">
      <PanelTravel  :key="key" @reloadTable="reloadTable" ref="PanelTravel" @verificarItens="verificarItens" :Situacao="Situacao" :tab="tab" :dataDetails="dataDetails"></PanelTravel>
    </div>
    <div class="col-md-9">
      <FormDetailsComission
        @podeCarregar="key = key + 1"
        ref="FormDetailsComission"
        @Situacao="Situacao = $event"
        @tabIndex="tab = $event"
        :dataDetails="dataDetails"
        @voltarPersonalizado="$emit('voltarPersonalizado')">
      </FormDetailsComission>
    </div>
  </div>
</template>

<script>
import DetailsTravelComission from './DetailsTravelComission'
export default DetailsTravelComission
</script>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/DetailsTravelComission/DetailsTravelComission.vue